import useLanguage from "../../../../utils/useLanguage";
import useUpdateDomTitle from "../../../../utils/updateDomTitle";
import { envEnums } from "../../../../enums/enums";

/**
 * Per-domain branding, mirroring the existing DefaultPage components so the
 * logo, links and footer stay consistent with the rest of the scanned page.
 */
const DOMAIN_CONFIG = {
    [envEnums.SCANNED_PAGE]: {
        logo: "/images/new_logo.webp",
        siteUrl: "https://online-qr-generator.com",
        supportEmail: "support@online-qr-generator.com",
        linkKeys: "defaultPage",
        footerKeys: ["defaultPage.footer_text_1", "defaultPage.footer_text_2"],
    },
    [envEnums.QCI]: {
        logo: "/images/qci/logo.webp",
        siteUrl: "https://qr-code.io",
        supportEmail: "support@qr-code.io",
        linkKeys: "qrc_io.defaultPage",
        footerKeys: ["qrc_io.defaultPage.footer_text_1", "qrc_io.defaultPage.footer_text_2"],
    },
    [envEnums.QGA]: {
        logo: "/images/qga/logo.webp",
        siteUrl: "https://qr-generator.ai",
        supportEmail: "support@qr-generator.ai",
        linkKeys: "qrc_io.defaultPage",
        footerKeys: ["qrgen_ai.defaultPage.footer_text_1", "qrgen_ai.defaultPage.footer_text_2"],
    },
    [envEnums.QGC]: {
        logo: "/images/qgc/logo.webp",
        siteUrl: "https://qr-generator.com",
        supportEmail: "support@qr-generator.com",
        linkKeys: "qrc_io.defaultPage",
        footerKeys: ["qgc.defaultPage.footer_text_1", "defaultPage.footer_text_2"],
    },
};

/**
 * Shown for SMS QR codes scanned from a desktop OS (Linux / Windows) that has
 * no handler for the `sms:` scheme.
 */
export default function SmsUnsupportedDevice() {
    const { t } = useLanguage();
    const config = DOMAIN_CONFIG[process.env.REACT_APP_DOMAIN] ?? DOMAIN_CONFIG[envEnums.SCANNED_PAGE];
    const headline = t("sms.unsupported_device_title");

    useUpdateDomTitle(headline);

    return (
        <div className="defualt-page 3xl:max-w-[1536px] 3xl:mx-auto mx-[25px] tablet:mx-[50px] xl:mx-[200px] tablet:min-h-screen tablet:max-h-screen my-[25px] tablet:my-[0px] gap-2 tablet:flex tablet:justify-center tablet:flex-col">
            <div className="my-auto">
                <div className="flex flex-col items-center justify-center gap-8 py-16 tablet:min-h-[600px] border-b-2 border-black">
                    <img
                        src={config.logo}
                        alt="logo"
                        loading="lazy"
                        className="w-[193px] tablet:w-[258px]"
                    />
                    <div className="flex w-full max-w-[620px] flex-col items-center justify-center gap-3 tablet:gap-4 rounded-[12px] border border-[#dcdfe4] bg-white px-8 py-12 text-center text-black">
                        <h1 className="text-[20px] tablet:text-[24px] font-semibold leading-10">{headline}</h1>
                        <p className="text-base tablet:text-lg font-medium leading-7">{t("sms.unsupported_device_description")}</p>
                    </div>
                </div>
                <div className="flex flex-row items-center sm:justify-center justify-between px-2 mt-4 space-x-5 sm:space-x-10 font-medium text-lg df-section">
                    <a href={`mailto:${config.supportEmail}?subject=Report%20abuse`}>{t(`${config.linkKeys}.report_abuse`)}</a>
                    <a href={`${config.siteUrl}/contact`} target="_blank" rel="noopener noreferrer">{t(`${config.linkKeys}.contact_us`)}</a>
                    <a href={`${config.siteUrl}/terms-and-conditions`} target="_blank" rel="noopener noreferrer">{t(`${config.linkKeys}.terms_text`)}</a>
                    <a href={`${config.siteUrl}/privacy-policy`} target="_blank" rel="noopener noreferrer">{t(`${config.linkKeys}.privacy_text`)}</a>
                </div>
                <div className="flex flex-row items-center justify-between px-2 df-footer pt-[1.5rem] pb-0">
                    <div className="font-medium">{t(config.footerKeys[0])}</div>
                    <div className="font-medium">{t(config.footerKeys[1])}</div>
                </div>
            </div>
        </div>
    );
}
